// enum ToolRole
export const ToolRole = {
  ROUGHING: 'ROUGHING',
  FINISHING: 'FINISHING',
  GENERAL_PURPOSE: 'GENERAL_PURPOSE',
  SPOTTING: 'SPOTTING',
  CENTER_DRILL: 'CENTER_DRILL',
}

export type ToolRole = typeof ToolRole[keyof typeof ToolRole]

export const TOOL_ROLES = {
  GENERAL_PURPOSE: 'General Purpose',
  ROUGHING: 'Roughing',
  FINISHING: 'Finishing',
  SPOTTING: 'Spotting',
  CENTER_DRILL: 'Center Drilling',
}
